export const getThemeMode = () => {
    const style = window.getComputedStyle(document.body);
    const colorScheme = style.getPropertyValue('color-scheme');
    // return browser's preference
    if (colorScheme === 'light dark') {
        return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
    }
    return colorScheme;
};
export const getPropertyValue = (property) => {
    var _a;
    const style = window.getComputedStyle(document.body);
    const propertyValue = style.getPropertyValue(property);
    const lightDarkValue = (_a = propertyValue.match(/light-dark\((.*)\)/)) === null || _a === void 0 ? void 0 : _a[1];
    if (lightDarkValue) {
        const themeMode = getThemeMode();
        const [lightValue, darkValue] = lightDarkValue.split(',');
        return themeMode === 'dark' ? darkValue : lightValue;
    }
    return propertyValue;
};
